import { GraphQLModuleConfigurationRepository } from "@app/repositories/GraphQLRepositories/ModuleConfigurationRepository";
import { useQuery } from "@tanstack/react-query";

const moduleConfigurationRepository =
    new GraphQLModuleConfigurationRepository();

export const moduleConfigurationKeys = {
    all: () => ["moduleConfiguration"] as const,
};

export function useModuleConfiguration() {
    const { data, isPending } = useQuery({
        queryKey: moduleConfigurationKeys.all(),
        queryFn: () => moduleConfigurationRepository.getModuleConfig(),
    });
    return { moduleConfiguration: data?.moduleConfig, isPending };
}
